<script setup lang="ts">
import useSwr from "@/core/composables/swr/useSwr";
import {disruptionLogisticsApi} from "@/container";
import HealthcenterGroupIcon from "@/disruption-logistics/components/healthcenter-groups/HealthcenterGroupIcon.vue";
import BaseButton from "@/core/components/base/BaseButton.vue";
import {pluralize} from "@/core/filters/Pluralize";
import InformationTooltip from "@/core/components/tooltips/InformationTooltip.vue";
import HealthcenterGroupPresentation
    from "@/disruption-logistics/components/healthcenter-groups/HealthcenterGroupPresentation.vue";

const {data} = useSwr(
    "disruption-logistics/healthcenter-groups/invitations/received",
    () => disruptionLogisticsApi().receivedHealthcenterGroupInvitations('pending')
);
</script>

<template>
  <div
    class="flex gap-2" :class="{
      'items-center': (data?.length ?? 0) > 0,
      'items-baseline': !data?.length,
    }"
  >
    <HealthcenterGroupIcon :size="32" />
    <div class="flex-1 flex flex-col">
      <p class="text-primary text-lg flex-1 relative">
        Invitez des pharmacies amies pour améliorer vos recherches
        <InformationTooltip class="w-4 h-4 relative top-0.5">
          <HealthcenterGroupPresentation class="group-tooltip text-sm" />
        </InformationTooltip>
      </p>
      <router-link v-if="data?.length" :to="{name: 'disruption-logistics.healthcenter-groups'}" class="text-sm self-start">
        <p>
          Vous avez {{ data.length }} {{ pluralize('invitation', data.length) }} en attente !
        </p>
      </router-link>
    </div>

    <BaseButton
      density="comfortable" class="text-primary self-center"
      :to="{name: 'disruption-logistics.healthcenter-groups'}"
    >
      Inviter des pharmacies
    </BaseButton>
  </div>
</template>

<style scoped>
.group-tooltip:deep(h1) {
    @apply text-white;
}
</style>
